import PropTypes from 'prop-types'
import { HeartPulse, Brain, Users, Briefcase, Wallet } from 'lucide-react'

const ICONS = { physical: HeartPulse, mental: Brain, relationships: Users, career: Briefcase, financial: Wallet }
const ORDER = ['physical', 'mental', 'relationships', 'career', 'financial']
const DOT = { Minimal: 'low', Low: 'low', Moderate: 'moderate', High: 'high', Critical: 'severe' }

function LifeImpactSection({ lifeImpact }) {
  if (!lifeImpact) return null
  return (
    <section className="section" aria-labelledby="life-h">
      <div className="section__head">
        <h2 id="life-h">Life impact</h2>
        <p className="section__desc">How much room each domain has, from 0 to 100. Longer is better; the label says how much your answers are weighing on it.</p>
      </div>
      <div className="bars">
        {ORDER.filter((k) => lifeImpact[k]).map((k) => {
          const d = lifeImpact[k]
          const Icon = ICONS[k]
          const score = Math.round(d.score)
          return (
            <div key={k} className="bar">
              <div className="bar__head">
                <Icon size={16} strokeWidth={2} />
                <span>{d.label}</span>
                <span className="bar__num">{score}</span>
              </div>
              <span className="bar__level">
                <span className={`bar__dot bar__dot--${DOT[d.impact?.level] || 'low'}`} aria-hidden="true" />
                {d.impact?.level === 'Minimal' ? 'Minimal load' : `${d.impact?.level} load`}
              </span>
              <div className="bar__track" role="img" aria-label={`${d.label}: ${score} of 100`}>
                <span className="bar__fill" style={{ width: `${score}%` }} />
              </div>
              <span className="bar__sub" style={{ gridColumn: '1 / -1' }}>{d.description}</span>
            </div>
          )
        })}
      </div>
    </section>
  )
}

LifeImpactSection.propTypes = {
  lifeImpact: PropTypes.object,
}

export default LifeImpactSection
